import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import { store } from '../_store/index.js';


Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  store,
  linkActiveClass: 'active',
  scrollBehavior: (to, from ,savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user');
  const publicPages = [
    '/forgot-password',
    '/login',
    '/register',
    '/reset-password'
  ];

  const authRequired = !publicPages.includes(to.path);

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  if (to.matched.some(record => record.meta.requiresAdmin)) {
    const role = store.getters.userIsAdmin;

    if (role) {
      return next();
    }

    return next('/dashboard');
  }

  return next();
});

export default router;
